import React, { useState } from "react";
import { Button, Col, Form, Row } from "reactstrap";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import SikkaInput from "../common/SikkaInput";
import Loader from "../common/Loader";

const MarketplaceStatusUpdateModal = ({
  publishServiceID,
  setOpenMarketplaceStatusUpdateModal,
  updatedStatus,
  setFetchAfterUpdate,
  mpApplicationStatus="",
  setMpApplicationStatus,
  setUpdatedStatus
}) => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const { loginUserDetails } = useContext(AppContext);
  const { register, handleSubmit, errors } = useForm();
  const handleUpdateMarketplaceStatus = (values) => {
    setFetchAfterUpdate(false);
    setLoading(true);
    // Call the API to update marketplace visibility
    let body = {
      sid: publishServiceID,
      comment: values.comment,
      new_status: updatedStatus.toLowerCase(),
      devid:
      loginUserDetails.is_partner == "1"
        ? loginUserDetails?.parent_dev_id
        : loginUserDetails?.dev_id,
      mp_application_status:mpApplicationStatus
    }; 
    APICall.servertrip(
      "PUT",
      "update_marketplace_visibility",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        toast.success(
          `Marketplace status successfully updated to ${mpApplicationStatus}`
        );
        setFetchAfterUpdate(true);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setFetchAfterUpdate(false);
      }
    ).finally(()=>{
        setMpApplicationStatus("");
        setUpdatedStatus("");
        setOpenMarketplaceStatusUpdateModal(false);
        setLoading(false);
    });
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={handleSubmit(handleUpdateMarketplaceStatus)}>
            <Row>
              <Col>
                <SikkaInput
                  label="Comment"
                  name="comment"
                  type="textarea"
                  id="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Write your comment"
                  innerRef={register({
                    required: "Comment is required",
                    pattern: {
                      value: /^[^\s]+(\s+[^\s]+)*$/,
                      message: "Invalid comment",
                    },
                  })}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row
              className="modal-footer px-md-3 bg-light"
              style={{
                marginLeft: "-16px",
                marginRight: "-16px",
                marginBottom: "-16px",
              }}
            >
              <Button
                color="outline-success"
                size="sm"
                className="ml-auto"
                type="submit"
                disabled={loading}
              >
                Update
              </Button>
              <Button
                size="sm"
                color="outline-secondary"
                onClick={() => {
                  setOpenMarketplaceStatusUpdateModal(false);
                }}
              >
                Cancel
              </Button>
            </Row>
          </Form>
        )}
      </div>
    </>
  );
};

export default MarketplaceStatusUpdateModal;
